import { render, staticRenderFns } from "./TrashedLayout.vue?vue&type=template&id=028ac50b&"
import script from "./TrashedLayout.vue?vue&type=script&lang=js&"
export * from "./TrashedLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports